import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_search } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { remote_search_update } from '@/state/search/remote_search_update';
import { SOrientationDropdown } from './SOrientationDropdown';

export function SOrientationBar() {
  const dispatch = use_dispatch();

  const { search_current } = use_slice_search(['search_current']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (search_current.orientations.is_empty()) return; //user already selected "search over all aspect ratios"
    if (search_current.orientations.length == 1) return; //user already selected some aspect ratio

    let search_new = search_current.clone({ orientations: [] });

    void dispatch(remote_search_update(search_new));
  });

  return search_current.is_stub() ? <PLACEHOLDER_bar_line /> : <SOrientationDropdown />;
}
